import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from '../api-services/Auth/auth.service';
import { ProfileService } from '../api-services/profile/profile.service';
import { TalkToDoctorService } from '../api-services/talk-to-doctor.service';


@Component({
  selector: 'app-member-profile',
  templateUrl: './member-profile.component.html',
  styleUrls: ['./member-profile.component.css']
})
export class MemberProfileComponent implements OnInit {
  @ViewChild('msg') modalRef;
  getDetails: any;
  maxdate: any
  memberForm = new FormGroup({
    firstName: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(35), Validators.pattern('^[a-zA-Z \-\']+')]),
    lastName: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(35), Validators.pattern('^[a-zA-Z \-\']+')]),
    email: new FormControl('', Validators.required),
    dob: new FormControl('', [Validators.required]),
    genderId: new FormControl('', [Validators.required]),
    type: new FormControl(''),
    address:new FormControl(''),
    phoneNumber: new FormControl('', [Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern(/^-?(0|[1-9]\d*)?$/)])
  });
  gender: any;
  getchangedName: any;
  constructor(private profile_$: ProfileService, private genderService: TalkToDoctorService, private modalService: BsModalService, private authService: AuthService) { }

  ngOnInit(): void {
    this.getchangedName = JSON.parse(sessionStorage.getItem('userInfo'));
    let date = new Date()
    this.maxdate = new Date(`${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear() - 18}`);
    this.genderService.getGender().subscribe(res => {
      this.gender = res
    })
    this.getProfileInfo();
  }

  getProfileInfo() {
    this.profile_$.getMemberProfile().subscribe(res => {
      this.getDetails = res;//console.log("res",res);
      if (this.getDetails) {
        this.memberForm.get('firstName').patchValue(this.getDetails.firstName);
        this.memberForm.get('lastName').patchValue(this.getDetails.lastName);
        this.memberForm.get('email').patchValue(this.getDetails.email);
        this.memberForm.get('dob').patchValue(this.getDetails.dob);
        //this.memberForm.get('genderId').patchValue((this.getDetails?.gender != null )?this.getDetails.gender?.genderId:'null');
        this.memberForm.get('genderId').patchValue(this.getDetails?.gender );
        this.memberForm.get('type').patchValue(this.getDetails.type);
        this.memberForm.get('phoneNumber').patchValue(this.getDetails.phoneNumber);
        this.memberForm.get('address').patchValue( this.getDetails.address);
      }
    })
  }

  editProfile() {
    if (!this.memberForm.valid) {
      return this.memberForm.markAllAsTouched();
    } else {
      this.profile_$.editMemberProfile(this.memberForm.value).subscribe((res: any) => {
        if (res.result) {
          this.modalService.show(this.modalRef, {
            initialState: {
              message: 'Profile has been successfully updated'
            }
          });
          this.getchangedName= this.memberForm.get('firstName').value;
          this.authService.setUpdateName({firstName:this.getchangedName});
          this.getProfileInfo()
        }

      }, err => {
        if (err.status != 500) {
          this.modalService.show(this.modalRef, {
            initialState: {
              backdrop: 'static',
              keyboard: false,
              message: 'Unable connect to server'
            }
          })
        }
      })

    }
  };

  modalClose() {
    this.modalService.config.initialState = "";
    this.modalService.hide();
  }




}

